import produce from "immer";
import { createAction, createReducer, createSlice } from "@reduxjs/toolkit";

//ACTIONS
//export const loadingFile = createAction("loadingFile");
//export const updateStepperState = createAction("updateStepperState");
//export const changeContentIncludeType = createAction("changeContentIcludeType");
//export const updateSegmentText = createAction("updateSegmentText");
export const downloadTrasnlactedFileAction = createAction("upload/downloadTrasnlactedFileAction");
//export const downloadTranslatedFileSuccess = createAction("Download/TranslatedFileSuccess");
//export const getTranslationSegmentsSuccess = createAction("getTranslationSegmentsSuccess");
//export const updateUploadModel = createAction("updateUpload");
//export const getFilteredSegmentsSuccess = createAction("getFilteredSegmentsSuccess");
//export const loadingModel = createAction("loadingModel");

const initModel = {
  uploadModel: {
    fileId: "",
    paragraphSegmentation: false,
    tags: [],
    include: false,
    containsHTML: true,
  },
  isLoading: true,
};

export const slice = createSlice({
  name: "uploadModel",
  initialState: initModel,
  reducers: {
    updateUploadModel: (state, action) => {
      state.uploadModel.fileId = action.payload.fileId;
      state.uploadModel.paragraphSegmentation = action.payload.paragraphSegmentation;
      state.uploadModel.tags = action.payload.tags;
      state.uploadModel.include = action.payload.include;
      state.isLoading = false;
      
    },
    loadingModel: (state) => {
      state.isLoading = true;
     
    },
    changeContentIncludeType: (state, action) => {
      state.uploadModel.containsHTML = action.payload.type.containsHTML;
      state.uploadModel.fileId = action.payload.type.fileId;
    },
  },
});

export const { updateUploadModel, loadingModel, changeContentIncludeType } = slice.actions;

const initState = {
  uploadedFile: {
    fileId: null,
    filterOptions: null,
    description: "",
    afterCharacter: "",
    beforeText: "",
    filterSpecificNotes: "",
    transUnits: [],
    plaintext: [],
  },
  completeFile: {},
  userJSON: {},
  stepperState: {
    activeStep: 0,
  },
  isLoading: false,
  error: false,
  success: false,
  show: false,
  sizeError: false,
  typeError: false,
  fileCountError: false,
  wordsCountError: false,
};

export const uploadFileSlice = createSlice({
  name: "uploadFile",
  initialState: initState,
  reducers: {
    updateStepperState: (state, action) => {
      state.stepperState.activeStep = action.payload.activeStep;
    },
    getTranslationSegmentsSuccess: (state, action) => {
      state.uploadedFile.fileId = action.payload.segments.fileId;
      state.uploadedFile.filterOptions = action.payload.segments.filterOptions;
      state.uploadedFile.description = action.payload.segments.description;
      state.uploadedFile.afterCharacter = action.payload.segments.afterCharacter;
      state.uploadedFile.beforeText = action.payload.segments.beforeText;
      state.uploadedFile.filterSpecificNotes = action.payload.segments.filterSpecificNotes;
      state.uploadedFile.transUnits = action.payload.segments.transUnits;
      state.uploadedFile.plaintext = action.payload.segments.transUnits;
      state.isLoading = false;
      state.error = false;
    },
    getFilteredSegmentsSuccess: (state, action) => {
      state.uploadedFile.fileId = action.payload.filteredSegments.fileId;
      state.uploadedFile.filterOptions = action.payload.filteredSegments.filterOptions;
      state.uploadedFile.description = action.payload.filteredSegments.description;
      state.uploadedFile.afterCharacter = action.payload.filteredSegments.afterCharacter;
      state.uploadedFile.beforeText = action.payload.filteredSegments.beforeText;
      state.uploadedFile.filterSpecificNotes = action.payload.filteredSegments.filterSpecificNotes;
      state.uploadedFile.transUnits = action.payload.filteredSegments.transUnits;
      state.isLoading = false;
      state.error = false;
      state.typeError = false;
    },
    updateSegmentText: (state, action) => {
      state.uploadedFile.transUnits[action.payload.id].segmentText = action.payload.segmentText;
    },
    downloadTranslatedFileSuccess: (state, action) => {
      state.completeFile = action.payload;
      state.isLoading = false;
      state.success = true;
    },
    setDownloadSuccess: (state) => {
      state.success = true;
    },
    loadingFile: (state) => {
      state.isLoading = true;
      state.show = false;
    },
    loadingEnd: (state) => {
      state.isLoading = false;
      state.show = true;
    },
    cancelLoading: (state) => {
      state.isLoading = false;
      state.error = true;
    },
    showEditor: (state) => {
      state.show = true;
    },
    showSizeError: (state, action) => {
      state.sizeError = action.payload;
      state.show = false;
    },
    filesCountError: (state, action) => {
      state.fileCountError = action.payload;
      state.show = false;
    },
    showFileTypeError: (state, action) => {
      state.typeError = action.payload;
      state.show = false;
    },
    showWordsCountError: (state, action) => {
      state.wordsCountError = false;
      state.show = false;
    },
    closeErrorWindow: (state) => {
      state.typeError = false;
      state.sizeError = false;
      state.fileCountError = false;
    },

    //Not used now
    updateFile: (state, action) => {
      state.uploadedFile.transUnits[action.payload.id].selected = action.payload.selected;
    },
  },
});

export const {
  updateStepperState,
  getTranslationSegmentsSuccess,
  getFilteredSegmentsSuccess,
  updateSegmentText,
  downloadTranslatedFileSuccess,
  loadingFile,
  updateFile,
  cancelLoading,
  setDownloadSuccess,
  showEditor,
  loadingEnd,
  showSizeError,
  filesCountError,
  showFileTypeError,
  closeErrorWindow,
  showWordsCountError,
} = uploadFileSlice.actions;



export const getFileState = (state) => (state = state.uploadedFile);
